// eslint-disable-next-line no-use-before-define
import React from 'react';
import { SVGWrapper } from '../../../../svg-wrapper/svg-wrapper';
import { SideBarIconSvg } from '../../../../../assets/icons/sidebar';
import { SideBarOpenIconSvg } from '../../../../../assets/icons/sidebaropen';
export const Icon = ({ onClick, isOpen, }) => {
    return (React.createElement("button", { onClick: onClick, className: `main-menu_icon ${isOpen ? 'open' : ''}` }, isOpen ? (React.createElement(SVGWrapper, { svg: SideBarOpenIconSvg })) : (React.createElement(SVGWrapper, { svg: SideBarIconSvg }))));
};
//# sourceMappingURL=icon.js.map